export class ScreenEvents {
	public static readonly BECAME_VISIBLE: string = 'ScreenEvents::BECAME_VISIBLE';
	public static readonly BECAME_INVISIBLE: string = 'ScreenEvents::BECAME_INVISIBLE';

	public static readonly SCREEN_RESIZED: string = 'ScreenEvents::SCREEN_RESIZED';

	public static readonly ORIENTATION_CHANGED: string = 'ScreenEvents::ORIENTATION_CHANGED';
	public static readonly LANDSCAPE_MODE: string = 'ScreenEvents::LANDSCAPE_MODE';
	public static readonly PORTRAIT_MODE: string = 'ScreenEvents::PORTRAIT_MODE';

	public static readonly FULLSCREEN_STATUS_CHANGED: string = 'ScreenEvents::FULLSCREEN_STATUS_CHANGED';
	public static readonly FULLSCREEN_EXITED: string = 'FULLSCREEN_EXITED';
	public static readonly FULLSCREEN_ENTERED: string = 'ScreenEvents::FULLSCREEN_ENTERED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/screen/ScreenEvents.ts